/**
 * @file: monitor.d.ts
 * @desc: monitor declaration
 * @author: zhangdaming.yida@bytedance.com
 */
export var NATIVE_MONITOR_STATUS;
(function (NATIVE_MONITOR_STATUS) {
    NATIVE_MONITOR_STATUS[NATIVE_MONITOR_STATUS["FAIL"] = 0] = "FAIL";
    NATIVE_MONITOR_STATUS[NATIVE_MONITOR_STATUS["SUCCESS"] = 1] = "SUCCESS";
})(NATIVE_MONITOR_STATUS || (NATIVE_MONITOR_STATUS = {}));
export var NATIVE_MONITOR_VALUE_ERROR_CODE = 10001;
